"use client";

import type { ChartData, FinancialSnapshotNarrative } from "@/lib/types/financial-snapshot";
import { ChartCard } from "../ChartCard";
import { ProfitabilityChart } from "../charts/ProfitabilityChart";
import { LeverageChart } from "../charts/LeverageChart";

interface Props {
  data: ChartData;
  narrative: FinancialSnapshotNarrative | null;
}

export function ProfitabilityTab({ data, narrative }: Props) {
  return (
    <div className="space-y-5">
      <ChartCard title="Profitability (ROE / ROCE)" caption={narrative?.insights.profitability}>
        <ProfitabilityChart rows={data.profitability} />
      </ChartCard>

      <ChartCard title="Leverage (D/E + Interest Coverage)" caption={narrative?.insights.leverage}>
        <LeverageChart rows={data.leverage} />
      </ChartCard>
    </div>
  );
}
